<template>
  <div>

    <main role="main">

      <div class="container">

        <div class="row">
          <div class="col-md-12">
            <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
              <i class="fa fa-chevron-circle-left"></i> {{ $t('text.globals.back') }}
            </a>
          </div>
        </div>

        <div class="row">

          <div class="col-md-12">

            <h2 class="preventLongStringOutbreak">
              {{ $t('text.uploadDocumentInLongTermStorageFormat.title') }}
            </h2>
          </div>

        </div>
        <div class="row">

          <loading :active.sync="isLoading"
                   :can-cancel="false"
                   :is-full-page="false"></loading>

          <div class="col-md-12">
            <div class="card mb-3 form-condensed">
              <div class="card-body bg-light">

                <div class="alert alert-danger" v-if="showCustomErrorMessage">
                  <i class="fa fa-2x fa-exclamation-triangle d-block float-left mt-1 mr-3"></i> {{ $t('text.uploadDocumentInLongTermStorageFormat.customErrorMessage') }}
                </div>


                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="file"> {{ $t('text.uploadDocumentInLongTermStorageFormat.fileForDownload') }}</label>


                      <input type="file" class="form-control" id="file"
                             @change="setFile"
                             aria-describedby="description"
                             ref="file"
                             name="file"
                      />

                    </div>
                  </div>

                </div>

                <div class="row mt-2">
                  <div class="col-md-12 text-right">
                    <a class="btn btn-primary text-white" @click="uploadFile()"><i class="fas fa-upload"></i>
                      {{ $t('text.uploadDocumentInLongTermStorageFormat.fileDownload') }}</a>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <a @click="$router.go(-1)" id="backBtn" class="btn btn-secondary text-white float-left">
              {{ $t('text.globals.back') }}
            </a>
          </div>
        </div>
      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import SidebarNavigation from '../components/SidebarNavigation';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import pdf from 'vue-pdf'


export default {
  name: 'DocumentDetails',
  components: {
    Vue,
    Loading,
    vSelect,
    pdf
  },

  data() {
    return {
      fileId: this.$route.params.id,
      allMetadataOptions: [],
      fileToUpload: null,
      isLoading: false,
      showCustomErrorMessage: false
    };
  },

  watch: {
    '$route': function () {
      this.getNode(this.$route.params.id);
    }
  },

  methods: {

    setFile() {
      const _this = this;
      _this.showCustomErrorMessage = false;

      if (_this.$refs.file.files[0]) {
        _this.fileToUpload = _this.$refs.file.files[0];
      }
    },

    uploadFile() {
      const _this = this;

      if (!_this.fileToUpload) {
        Vue.$toast.open({
          message: this.$t('text.uploadDocumentInLongTermStorageFormat.fileForDownloadNotSelectedToast'),
          type: 'error',
          position: 'top-right'
        });

        return;
      }

      _this.isLoading = true;

      let formData = new FormData();
      formData.append("content", _this.$refs.file.files[0]);

      axios.post(config.rootEhramba + 'longTermManualUpload?nodeId=' + _this.fileId, formData)
          .then((res) => {

            Vue.$toast.open({
              message: this.$t('text.uploadDocumentInLongTermStorageFormat.fileUploadSuccessToast'),
              type: 'success',
              position: 'top-right'
            });

            setTimeout(function () {
              _this.isLoading = false;
              _this.$router.push({name: 'DocumentInLongTermStorageDetails', params: {id: _this.fileId}})
            }, 500);
          })
          .catch((error) => {
            console.error(error);

            _this.isLoading = false;
            _this.showCustomErrorMessage = true;

            Vue.$toast.open({
              message: this.$t('text.uploadDocumentInLongTermStorageFormat.fileUploadErrorToast'),
              type: 'error',
              position: 'top-right'
            });

          });


    }


  },

  mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
    let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");

    Promise.all([p1, p2]).then((values) => {
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
    });

  }


};
</script>



// WEBPACK FOOTER //
// src/pages/UploadDocumentInLongTermStorageFormat.vue